import { render, staticRenderFns } from "./EditAccountPass.vue?vue&type=template&id=53e94437&scoped=true&"
import script from "./EditAccountPass.vue?vue&type=script&lang=js&"
export * from "./EditAccountPass.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountPass.vue?vue&type=style&index=0&id=53e94437&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e94437",
  null
  
)

export default component.exports